(function () {
    "use strict";

    function updateList() {
        document.querySelectorAll(".sports-ground-cmp").forEach((cmp) => {
            const selectSportsGround = cmp.querySelector("select[name='sportsGround']");
            const selectShowFields = cmp.querySelector("select[name='showFields']");

            const park = selectSportsGround?.value || "";
            const showFields = selectShowFields?.value || "";

            const [subName, parkName = ""] = park.split("|");

            document.querySelectorAll(".sports-ground-card").forEach((card) => {
                const isAllParks = park === "All";
                const matchesPark = isAllParks || (card.dataset.name === parkName && card.dataset.suburb === subName);

                if (!matchesPark) {
                    card.style.display = "none";
                    return;
                }

                const playAreas = card.querySelectorAll(".play-area");
                let cardHasMatchingField = !showFields;

                playAreas.forEach((pa) => {
                    const matchesStatus = !showFields || pa.dataset.status === showFields;
                    pa.style.display = matchesStatus ? "" : "none";

                    if (matchesStatus) {
                        cardHasMatchingField = true;
                    }
                });

                card.style.display = cardHasMatchingField ? "" : "none";
            });
        });
    }

    // Event Delegation: Listen for change events on select or input within sports ground components
    document.addEventListener("change", (event) => {
        if (event.target.closest(".sports-ground-cmp select, .sports-ground-cmp input")) {
            updateList();
        }
    });
})();